import { createTheme } from "@mui/material/styles";

// Create a theme instance
const theme = createTheme({
  palette: {
    primary: {
      main: "#3f51b5",
      light: "#757de8",
      dark: "#002984",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f50057",
      light: "#ff4081",
      dark: "#c51162",
      contrastText: "#ffffff",
    },
    error: {
      main: "#f44336",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Public Sans", "Helvetica", "Arial", sans-serif',
    fontWeightRegular: 500,
    body1: {
      color: "rgb(107, 114, 128)",
      fontWeight: 500,
    },
    body2: {
      color: "rgb(107, 114, 128)",
      fontWeight: 500,
    },
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 500,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 4,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.1)",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: "rgb(107, 114, 128)", // gray-500
        },
        head: {
          color: "rgb(107, 114, 128)", // gray-500
          fontWeight: 600,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            color: "rgb(107, 114, 128)", // gray-500
          },
          "& .MuiOutlinedInput-input": {
            color: "rgb(107, 114, 128)", // gray-500
          },
          "& .MuiFilledInput-input": {
            color: "rgb(107, 114, 128)", // gray-500
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderWidth: "1px",
              borderColor: "rgba(0, 0, 0, 0.23)", // Default border color
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: "rgb(107, 114, 128)", // gray-500
        },
        select: {
          color: "rgb(107, 114, 128)", // gray-500
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "rgb(107, 114, 128)", // gray-500
        },
        input: {
          color: "rgb(107, 114, 128)", // gray-500
        },
      },
    },
  },
});

export default theme;
